import React from 'react';
import PropTypes from 'prop-types';
import { Label } from '../../components/widgets';
import { isSideAxisChart } from '../../components/partials/PivotChart/axisConfig';
import RangeInputs from './RangeInputs';
import MetricSideRow from './MetricSideRow';
import css from './AxisSettings.css';

const EMPTY_RANGE = { min: null, max: null };

const AxisSettings = ({ chartType, metrics, multiMetric, value, onChange }) => {
    const showSides = isSideAxisChart(chartType) && multiMetric;

    if (!showSides) {
        const range = (value && value.range) || EMPTY_RANGE;
        return (
            <div className={css.container}>
                <Label className={css.fieldLabel} text="STATIC.PAGES.DASHBOARD.SHELF.AXIS.VALUE_RANGE" />
                <RangeInputs idPrefix="single" range={range} onChange={next => onChange({ range: next })} />
            </div>
        );
    }

    const sides = (value && value.sides) || {};
    const left = (value && value.left) || EMPTY_RANGE;
    const right = (value && value.right) || EMPTY_RANGE;

    const emit = patch => onChange({ sides, left, right, ...patch });

    const setSide = (metricName, side) => {
        const nextSides = { ...sides };
        if (side === 'auto') {
            delete nextSides[metricName];
        } else {
            nextSides[metricName] = side;
        }
        emit({ sides: nextSides });
    };

    return (
        <div className={css.container}>
            <Label className={css.fieldLabel} text="STATIC.PAGES.DASHBOARD.SHELF.AXIS.METRIC_SIDE" />
            {metrics.map(metric => (
                <MetricSideRow
                    key={metric.name}
                    metricName={metric.name}
                    label={metric.display_name || metric.name}
                    side={sides[metric.name]}
                    onChange={setSide}
                />
            ))}
            <div className={css.ranges}>
                <div className={css.rangeCol}>
                    <Label className={css.fieldLabel} text="STATIC.PAGES.DASHBOARD.SHELF.AXIS.LEFT_RANGE" />
                    <RangeInputs idPrefix="left" range={left} onChange={next => emit({ left: next })} />
                </div>
                <div className={css.rangeCol}>
                    <Label className={css.fieldLabel} text="STATIC.PAGES.DASHBOARD.SHELF.AXIS.RIGHT_RANGE" />
                    <RangeInputs idPrefix="right" range={right} onChange={next => emit({ right: next })} />
                </div>
            </div>
        </div>
    );
};

AxisSettings.propTypes = {
    chartType: PropTypes.string.isRequired,
    multiMetric: PropTypes.bool,
    metrics: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string.isRequired,
            display_name: PropTypes.string,
        })
    ).isRequired,
    value: PropTypes.shape({
        sides: PropTypes.objectOf(PropTypes.oneOf(['left', 'right'])),
        left: PropTypes.shape({ min: PropTypes.number, max: PropTypes.number }),
        right: PropTypes.shape({ min: PropTypes.number, max: PropTypes.number }),
        range: PropTypes.shape({ min: PropTypes.number, max: PropTypes.number }),
    }),
    onChange: PropTypes.func.isRequired,
};

export default AxisSettings;
